import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';

import getInvoices from './getInvoices';
import { UseInvoicesError, UseInvoicesLoading, UseInvoicesResult } from './types';

const useInvoices = () => {
  const context = useVSFContext();
  const loading = sharedRef(false, `useInvoices/loading`);
  const result = sharedRef(null, `useInvoices`);
  const error = sharedRef(null, `useInvoices/error`);

  const refs = {
    loading,
    result,
    error,
  };

  return {
    getInvoices: getInvoices(context, refs),
    result: computed<UseInvoicesResult>(() => result.value),
    loading: computed<UseInvoicesLoading>(() => loading.value),
    error: computed<UseInvoicesError>(() => error.value),
  };
};

export default useInvoices;
